import Layout from '@components/layout';
import { pathnameToText } from '@components/layout/top-bar/data';
import Spinner from '@components/spinner';
import Digilocker from '@containers/form-verification/digilocker';
import { updateDocumentTitle } from '@global/helpers/general';
import { Box } from '@mui/material';
import { RootState } from '@redux/store';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

// Lazy loaded components
const BasicDetails = React.lazy(() => import('@containers/form-verification/basic-details'));
const FormSuccess = React.lazy(() => import('@containers/form-verification/completed/success'));
const FormPayments = React.lazy(() => import('@containers/form-verification/formPayments'));
const InsuffVerification = React.lazy(() => import('@containers/form-verification/insufficiency'));
const ProfileModeSelect = React.lazy(
  () => import('@containers/form-verification/profile/mode-select')
);
const Verification = React.lazy(() => import('@containers/form-verification/verification'));
const VerificationInfo = React.lazy(
  () => import('@containers/form-verification/verification/info')
);
const Home = React.lazy(() => import('@containers/home'));
const FormTxns = React.lazy(() => import('@containers/home/form-txns'));
const Notifications = React.lazy(() => import('@containers/notifications'));
const Payment = React.lazy(() => import('@containers/payment'));
const Mode = React.lazy(() => import('@containers/payment/mode'));
const ContactDetails = React.lazy(() => import('@containers/payment/mode/contact-details'));
const PaymentProvider = React.lazy(() => import('@containers/payment/provider'));
const TransactionHistory = React.lazy(() => import('@containers/payment/transaction-history'));
const Profile = React.lazy(() => import('@containers/profile'));

const App = ({ commonRoutes }: { commonRoutes: React.ReactNode }) => {
  const location = useLocation();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const auth: any = useSelector((s: RootState) => s.auth);
  const formData: any = useSelector((s: RootState) => s.formData);
  const { accessToken } = auth;

  useEffect(() => {
    updateDocumentTitle([pathnameToText(location.pathname), formData?.txnInfo?.form?.name]);
  }, [location.pathname, formData?.txnInfo?.form?.name]);

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        flexFlow: 'column'
        // ml: isDesktop() ? '30%' : 'auto',
        // mr: isDesktop() ? '30%' : 'auto'
      }}>
      <div
        id="wallet-container"
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          // height: '100vh'
          overflowY: accessToken ? 'hidden' : 'auto',
          backgroundColor: '#F6F9FC'
        }}>
        <React.Suspense fallback={<Spinner />}>
          <Routes>
            {accessToken ? (
              <Route path="/" element={<Layout />}>
                {commonRoutes}
                <Route path="/profile-mode" element={<ProfileModeSelect />} />
                <Route path="/basic-details" element={<BasicDetails />} />
                <Route path="/notifications" element={<Notifications />} />
                <Route path="/verification" element={<Verification />} />
                <Route path="/verification-info" element={<VerificationInfo />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/digilocker" element={<Digilocker />} />
                <Route path="/transaction-history" element={<TransactionHistory />} />
                <Route path="/choose-payment-region" element={<PaymentProvider />} />
                <Route path="/payment" element={<Payment />} />
                <Route path="/form-payments" element={<FormPayments />} />
                <Route path="/select-mode" element={<Mode />} />
                <Route path="/contact-details" element={<ContactDetails />} />
                <Route path="/verification/insufficiency" element={<InsuffVerification />} />
                <Route path="/submitted" element={<FormSuccess />} />
                <Route path="/form-txns" element={<FormTxns />} />
                <Route path="/" element={<Home />} />
                <Route path="*" element={<Navigate to="/" />} />
              </Route>
            ) : null}
          </Routes>
        </React.Suspense>
      </div>
    </Box>
  );
};

export default App;
